import { gql } from "@apollo/client"

const KNOW_YOUR_FARMER = gql`
  query kyfDetails($id: ID!) {
    kyfDetails(id: $id) {
      farmerName
      farmLocation {
        latitude
        longitude
        village
        taluka
        district
        state
        pincode
      }
      farmArea
      sowingDate
      harvestingDate
      organisationName
      organisationPhoto
      organisationLink
      organisationEmail
      organisationContact
      photo
      varietyName
    }
  }
`

export default KNOW_YOUR_FARMER
